function Download(){
    return(
        <div>
            <div class="download">
        <div class="container">
            <div class="row justify-content-center d-flex align-items-center text-center">
                <div class="col-md-12">
                    <h3>
                        Stop waiting.<br></br>
                        Start building.
                    </h3>
                    <button class="btn btn-outline-danger">DownLoad For Free</button>
                </div>
            </div>
        </div>
    </div>
        </div>
    )
}

export default Download ;